
import React from 'react';
import { Input, Button, Space } from 'antd';
import { SearchOutlined,FilterFilled } from '@ant-design/icons';

const parseDate = (val) => {
	if (!val) return null;
	if (val instanceof Date) return val;
	// Handle DD-MM-YYYY (e.g., 24-09-2023)
	const dmy = /^\s*(\d{1,2})-(\d{1,2})-(\d{4})\s*$/.exec(val);
	if (dmy) {
		const [, dd, mm, yyyy] = dmy;
		// construct ISO date string to avoid timezone issues
		const iso = `${yyyy.padStart(4, '0')}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}T00:00:00`;
		const dt = new Date(iso);
		return isNaN(dt) ? null : dt;
	}

	// Handle YYYY-MM-DD or other ISO formats
	const isoTry = new Date(val);
	return isNaN(isoTry) ? null : isoTry;
};

export const getColumnSearchProps = (dataIndex) => ({
	filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
		<div style={{ padding: 8 }}>
			<Input
				placeholder={`Search...`}
				value={selectedKeys[0]}
				onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
				onPressEnter={() => confirm()}
				style={{ marginBottom: 8, display: 'block' }}
			/>
			<Space>
				<Button type="primary" onClick={() => confirm()} size="small">Search</Button>
				<Button onClick={() => { clearFilters(); confirm(); }} size="small">Reset</Button>
			</Space>
		</div>
	),
	filterIcon: filtered => <SearchOutlined style={{ color: "white" }} />,
	onFilter: (value, record) => {
		const recordVal = record[dataIndex];
		return recordVal ? recordVal.toString().toLowerCase().includes(value.toLowerCase()) : false;
	},
});

export const dateSorter = (key) => (a, b) => {
	const da = parseDate(a && a[key]) || new Date(0);
	const db = parseDate(b && b[key]) || new Date(0);
	return +da - +db;
};

export const getColumnFilters = (dataIndex, options = []) => ({
	filters: options.map(opt => ({ text: opt, value: opt })),
	filterMultiple: true,
	onFilter: (value, record) => {
		const recordVal = record[dataIndex];
		if (recordVal == null) return false;
		return recordVal.toString().toLowerCase() === value.toString().toLowerCase();
	},
	filterIcon: (filtered) => ( <FilterFilled style={{ color: "white" }} />),
});

export default {
	getColumnSearchProps,
	dateSorter,
	getColumnFilters,
};
